const data = {
  id: "policing",
  title: "Law Enforcement & Accountability",
  intro: "Money, money, money, money. The police budget keeps growing — and not just because of Huntsville's record-breaking misconduct lawsuits. Where it's going, who's approving it, and what residents are getting in return — documented.",
  tabs: [
    {
      id: "hpd",
      label: "HPD",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "sheriff",
      label: "Madison County Sheriff",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
